import { getSdk } from '@/utils/devSdk'

export type BridgeAuth = {
  jwt: string
  orgId: string
  userId: string
  userName: string
  memberId: string
}

type WorkspaceChangedPayload = {
  kind?: string
  workspace?: Record<string, unknown>
}

/** 宿主未就绪时 executeCommand 会挂起；超时后交给调用方展示失败/重试。 */
function withTimeout<T>(p: Promise<T>, ms: number): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`timeout after ${ms}ms`)), ms)
    p.then(
      (v) => {
        clearTimeout(timer)
        resolve(v)
      },
      (e) => {
        clearTimeout(timer)
        reject(e)
      },
    )
  })
}

export const bridge = {
  /** 宿主已登录时取 JWT，不走开发者平台自己的 OAuth 页。 */
  async getAuth(): Promise<BridgeAuth | null> {
    const sdk = await getSdk()
    if (!sdk) return null
    try {
      const info = (await withTimeout(
        sdk.executeCommand('org-menu.getBaseInfo'),
        3000,
      )) as Record<string, unknown>
      const workspace = info.workspace as Record<string, unknown> | undefined
      const userInfo = info.userInfo as { userId?: string; name?: string } | undefined
      const jwt = typeof info.token === 'string' ? info.token : ''
      if (!jwt) return null
      return {
        jwt,
        orgId: typeof workspace?.id === 'string' ? workspace.id : '',
        userId: userInfo?.userId ?? '',
        userName: userInfo?.name ?? '',
        memberId: typeof workspace?.my_member_id === 'string' ? workspace.my_member_id : '',
      }
    } catch (error) {
      console.warn('[bridge] org-menu.getBaseInfo failed / timed out:', error)
      return null
    }
  },

  onOrgSwitch(handler: (data: { orgId: string }) => void): () => void {
    let cancelled = false
    let off = () => {}
    void getSdk().then((sdk) => {
      if (!sdk || cancelled) return
      off = sdk.onEvent('org-menu.workspaceChanged', (data) => {
        const payload = data as WorkspaceChangedPayload
        const orgId = payload.workspace?.id
        if (payload.kind === 'currentChanged' && typeof orgId === 'string' && orgId) {
          handler({ orgId })
        }
      })
    })
    return () => {
      cancelled = true
      off()
    }
  },
}
